export class SelectOccupancy {
  constructor() {
    this.AVAILABLE = 0;
    this.OCCUPIED = 0;

  }
  AVAILABLE: number;
  OCCUPIED: number;
}
